import React from 'react';
import styled from 'styled-components';

import { LoadingIndicator } from 'components/LoadingIndicator';
import { RenderWithDelay } from 'containers/RenderWithDelay';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export function LoadingSection({ delay }: { delay?: number }) {
  return (
    <RenderWithDelay delay={delay}>
      <Container>
        <LoadingIndicator />
      </Container>
    </RenderWithDelay>
  );
}
